export default __webpack_public_path__ + "static/media/check_box_default.83d35e2d.svg";